import React, { memo, useEffect, useState, Fragment, useCallback } from 'react'
import { inject, observer } from 'mobx-react'
import { ArrowLeftCircle, MoreHorizCircle, Trash, User } from 'iconoir-react'
import {
  AiOutlineComment,
  AiOutlineDelete,
  AiOutlineQuestionCircle,
  AiFillBank,
  AiOutlineEdit,
} from 'react-icons/ai'
import { useNavigate, useParams } from 'react-router-dom'
import {
  Menu,
  MenuItem,
  useTheme,
  Box,
  Stepper,
  Step,
  StepLabel,
  StepContent,
} from '@mui/material'
import { Button, Modal, Table, Tag } from 'antd'
import SkeletonTable from '../../components/Skeleton/SkeletonTable'
import {
  ASSIGNEE_TYPE,
  MODES,
  SHIFTS,
  TYPE_STATUS,
  submissionMenu,
} from '../../utils/constants'
import { StatusTag } from '../../components/common/StatusTag'
import { AvatarHasName } from '../../components/common/Avatar'
import { getExtensionFile } from '../../utils/common'
import moment from 'moment'
import SelectPeoplePopup from '../../components/SelectPeoplePopup'
import SkeletonProposalDetail from '../../components/Skeleton/SkelentonProposalDetail'
// import ProposalComment from './ProposalComment'
// import ListComment from './ListComment'
import AlertDialog from '../../components/common/AlertDialog'
import { ACL_ACTION_TYPE, PROPOSAL_STATUS } from '../../constants'
import FileItem from '../../components/FileItemComponent/FileItem'
// import UpdateProposal from './UpdateModal'
import { message } from 'antd'
import { toJS } from 'mobx'
import { SelectList } from '../InternalDocumentIncoming/InternalDocumentIncomingDocCreatePageStyled'
import AccessControlAction from '../../components/AccessControlAction/AccessControlAction'
// import ProposalActionConfirmModal from './ProposalActionConfirmModal'
import './ProposalSalaryDetailPage.css'
import ProposalModal from '../Proposal/ProposalModal'
import ListComment from '../Proposal/ListComment'
import SalaryComment from './SalaryComment'
import utils from '../../utils'
import SalaryList from './SalaryList'
import SalaryInfo from './SalaryInfo'
import ProposalSalaryDetailAction from './ProposalSalaryDetailAction'
const groupBtnStyle = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 10,
  marginBottom: 10,
}
const show = {
  flex: '0 0 360px',
  width: 360,
  transition: '0.5s',
  overflow: 'hidden',
}
const hide = {
  flex: '0 0 0',
  width: 0,
  transition: '0.5s',
  overflow: 'hidden',
}
const ProposalSalaryDetailPage = props => {
  let {
    proposalStore,
    selectPeopleStore,
    proposalTypeStore,
    authenticationStore,
    proposalSalaryStore,
  } = props
  const navigate = useNavigate()
  const theme = useTheme()
  const { proposalId } = useParams()
  const [loading, setLoading] = useState(true)
  const [loadingCmt, setLoadingCmt] = useState(false)
  const [handlerList, setHandlerList] = useState([])
  const [followerList, setFollowerList] = useState([])
  const [isVisibleSelectUserPopup, setIsVisibleSelectUserPopup] =
    useState(false)
  const [openModal, setOpenModal] = useState(false)
  const [openCmtModal, setOpenCmtModal] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)
  const [openMore, setOpenMore] = useState(false)
  const [openCmtDel, setOpenCmtDel] = useState(false)
  const [openEditProposal, setOpenEditProposal] = useState(false)
  const [activeStep, setActiveStep] = useState(0)
  const [approvalLevels, setApprovalLevels] = useState([])
  const [params, setParams] = useState({
    page: 0,
    size: 10,
    keyword: undefined,
    proposalStatus: undefined,
    type: undefined,
    proposal_permission: undefined,
  })

  const [count, setCount] = useState(0)

  const [deleteItem, setDeleteItem] = useState({
    open: false,
    id_comment: '',
  })
  const [messages, setMessage] = useState({
    title: '',
  })
  const [isOpen, setIsOpen] = useState({
    isOpen: false,
  })

  const [arrSubmissionMenu, setArrSubmissionMenu] = useState([])
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isLoadingSalary, setIsLoadingSalary] = useState(false)
  const [isLoadingDetailSalary, setIsLoadingDetailSalary] = useState(false)
  const [salaryData, setSalaryData] = useState([])
  const open = Boolean(anchorEl)

  const {
    otherDetail,
    otherCommentList,
    getOtherComment,
    deleteCommentProposal,
    deleteProposalItem,
  } = proposalStore
  const { isShowSalaryInfo, salaryInfo } = proposalSalaryStore
  const { proposalId: salaryCode } = useParams()
  const { selectUserData, originDepartmentWithUserList } = selectPeopleStore
  const { currentUser } = authenticationStore
  // sử lý thêm loại khác vào submissionMenu
  useEffect(() => {
    if (salaryCode) {
      ;(async () => {
        try {
          setIsLoadingDetailSalary(true)
          const response = await proposalSalaryStore.getSalaryDetail(salaryCode)
          setSalaryData(response)
        } catch (err) {
          // console.log(err)
          message.error(err.vi || 'Đã có lỗi xảy ra!')
        } finally {
          setIsLoadingDetailSalary(false)
        }
      })()
    }
    return () => {
      proposalSalaryStore.clearSalary()
    }
  }, [salaryCode])
  // xử lý duyệt hành chính
  const [isShowButtonAction, setIsShowButtonAction] = useState(false)
  const [confirmModalType, setConfirmModalType] = useState(null)
  const [isConfirmModalVisible, setIsConfirmModalVisible] = useState(false)
  useEffect(() => {
    if (!currentUser) return
    const currentStepInfo = proposalStore.otherDetail.approval_levels?.find(
      item => item.status === PROPOSAL_STATUS.PENDING
    )
    if (currentUser.username === currentStepInfo?.username) {
      setIsShowButtonAction(true)
    } else {
      setIsShowButtonAction(false)
    }
  }, [proposalStore.otherDetail, currentUser])

  const handleCloseModal = useCallback(() => {
    setIsConfirmModalVisible(false)
    setConfirmModalType(null)
  }, [])

  const handleOpenConfirmModal = modalType => {
    setConfirmModalType(modalType)
    setIsConfirmModalVisible(true)
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true)
        await proposalStore.getOtherDetail(proposalId)
      } catch (err) {
        // console.log(err)
        navigate('/proposal')
        await proposalStore.getProposals(params)
        message.error('Không tìm thấy người dùng')
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [])
  useEffect(() => {
    proposalStore.getOtherDetail(proposalId)
  }, [count])
  useEffect(() => {
    ;(async () => {
      setLoadingCmt(true)
      await getOtherComment(proposalId)
      setLoadingCmt(false)
    })()
  }, [])
  const approvalLevelList = otherDetail?.approval_levels || []

  const onCommentSuccess = async () => {
    try {
      setLoadingCmt(true)
      await Promise.all([getOtherComment(proposalId)])
    } catch (err) {
      // console.log(err)
    } finally {
      setLoadingCmt(false)
    }
  }

  const ASSIGNEE_TYPE_CONFIG = [
    ASSIGNEE_TYPE.CREATE,
    ASSIGNEE_TYPE.COMBINER,
    ASSIGNEE_TYPE.HANDLER,
    ASSIGNEE_TYPE.LEADER,
  ]

  const commentProposalListNotDeleted = otherCommentList?.filter(
    item => item.deleted !== true
  )
  const commentProposalListDeleted = otherCommentList?.filter(
    item => item.deleted === true
  )

  const [statusStep, setStatusStep] = useState('process')
  const [workingDaysList, setWorkingDaysList] = useState([])

  const getInfoUser = (username, departmentWithUserList) => {
    const user = {
      full_name: username,
      image_id: null,
      username: username,
    }
    departmentWithUserList.forEach(department => {
      const userTarget = department.users.find(
        user => user.user_name === username
      )
      if (userTarget) {
        user.full_name = userTarget.name_uppercase || username
        user.image_id = userTarget.image_id
      }
    })
    return user
  }

  const handleSubmitSelectUser = useCallback(() => {
    setIsVisibleSelectUserPopup(false)
  }, [])

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleDeleteComment = async () => {
    setDeleteItem({ open: false, comment_id: '' })
    try {
      setLoadingCmt(true)
      await deleteCommentProposal(proposalId, deleteItem.id_comment)
      await getOtherComment(proposalId)
    } catch (err) {
      setMessage({ title: err.vi })
      setIsOpen({ isOpen: true })
    } finally {
      setLoadingCmt(false)
      message.success('Xóa ý kiến thành công!')
    }
  }
  const handleDeleteProposal = async () => {
    try {
      await deleteProposalItem(proposalId)
    } catch (err) {
      // console.log(err)
    } finally {
      message.success('Xóa thành công!')
      navigate('/proposal')
    }
  }

  const { confirm } = Modal
  const showConfirmDeleteProposal = () => {
    confirm({
      title: 'Bạn có muốn xóa thông tin này không?',
      icon: (
        <AiOutlineQuestionCircle
          style={{ color: 'red', width: '30px', height: '30px' }}
        />
      ),
      okText: 'Đồng ý',
      cancelText: 'Không',
      okType: 'danger',
      onOk() {
        handleDeleteProposal()
      },
    })
  }

  // Chữ cái đầu viết hoa
  const capitalizeFirstLetter = name => {
    return name
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
  }

  let menu = (
    <Menu
      id="basic-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      MenuListProps={{
        'aria-labelledby': 'basic-button',
      }}>
      {openMore ? (
        <MenuItem
          sx={{
            color: '#0073C7 !important',
            borderBottom: '1px solid rgba(0,0,0,0.05)',
            fontSize: '12px',
          }}
          onClick={() => {
            setOpenMore(false)
            setOpenCmtDel(false)
            handleClose()
          }}>
          <Trash width={12} height={14} className="mr-1" />
          Ẩn ý kiến đã xóa
        </MenuItem>
      ) : (
        <MenuItem
          onClick={() => {
            setOpenMore(true)
            setOpenCmtDel(true)
            handleClose()
          }}
          sx={{
            color: '#0073C7 !important',
            borderBottom: '1px solid rgba(0,0,0,0.05)',
            fontSize: '12px',
          }}>
          <Trash width={12} height={14} className="mr-1" />
          Hiện ý kiến đã xóa
        </MenuItem>
      )}
    </Menu>
  )

  const renderStatus = (status, isRejected) => {
    const styleTag = {
      marginTop: 8,
      borderRadius: 10,
    }

    if (status === PROPOSAL_STATUS.PENDING) {
      return (
        <Tag
          color={isRejected ? null : 'geekblue'}
          style={{
            ...styleTag,
            opacity: isRejected ? 0.5 : 1,
          }}>
          Đến lượt duyệt
        </Tag>
      )
    }
    if (status === PROPOSAL_STATUS.WAITING) {
      return (
        <Tag
          color={isRejected ? null : 'orange'}
          style={{
            ...styleTag,
            opacity: isRejected ? 0.5 : 1,
          }}>
          Chờ duyệt
        </Tag>
      )
    }

    if (status === PROPOSAL_STATUS.CREATED) {
      return (
        <Tag color={'cyan'} style={styleTag}>
          Đã tạo
        </Tag>
      )
    }
    if (status === PROPOSAL_STATUS.APPROVED) {
      return (
        <Tag color={'green'} style={styleTag}>
          Đã duyệt
        </Tag>
      )
    }
    if (status === PROPOSAL_STATUS.REJECTED) {
      return (
        <Tag color={'red'} style={styleTag}>
          Đã từ chối
        </Tag>
      )
    }
  }

  // Tìm title của proposal_type
  const proposalTypeName = arrSubmissionMenu
    ?.find(el =>
      el.child.find(els => els.id_child === otherDetail?.proposal_type)
    )
    ?.child.find(els => els.id_child === otherDetail?.proposal_type)

  const numberOfColumns =
    otherDetail?.proposal_type !== 'BUSINESS_TRIP' &&
    otherDetail?.proposal_type !== 'OVERTIME_NORMAL'
      ? 4
      : 3
  const columnWidth = `${100 / numberOfColumns}%`

  const handleNavigateBack = async () => {
    if (isModalOpen) {
      navigate(-2)
    } else {
      navigate(-1)
    }
    await proposalStore.getProposals(params)
  }
  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }
  return (
    <>
      {loading ? (
        <SkeletonProposalDetail />
      ) : (
        <Fragment>
          <div
            className="flex items-center gap-[22px] fixed w-full z-50"
            style={{
              background: theme.background.header,
              color: theme.color.text1,
            }}>
            <ArrowLeftCircle
              style={{ marginLeft: '10px' }}
              className="flex-shrink-0"
              onClick={handleNavigateBack}
            />
            <div className="w-full h-20 flex items-center justify-between overflow-hidden">
              <div
                className="font-bold text-[28px] leading-[29px] truncate w-1/2"
                style={{
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis',
                  width: '100%',
                  lineHeight: '35px',
                }}>
                {otherDetail.title}
              </div>
              <div className="w-1/2 flex justify-end pr-2">
                <StatusTag
                  typePage={TYPE_STATUS.PROPOSAL}
                  status={otherDetail.proposal_status}
                />
              </div>
            </div>
          </div>
          <div className="mb-24 pt-20">
            {!isLoadingDetailSalary &&
            salaryInfo &&
            !salaryInfo?.has_no_config_approval_levels ? (
              <ProposalSalaryDetailAction />
            ) : (
              <></>
            )}

            <div className="m-4 border border-[#2c65ac] rounded-lg">
              <div
                className="bg-blue-600 px-4 py-2 rounded-t-lg"
                style={{
                  background: theme.background.header,
                  color: theme.color.text1,
                }}>
                Thông tin chung
              </div>
              <div className="m-4">
                {/* Loại hành chính */}
                <div className="mb-3">
                  <span className="font-bold mr-1">Loại:</span>
                  {proposalTypeName?.name_child}
                </div>

                {/* Tài liệu đính kèm */}
                <div>
                  <div className="flex">
                    <div className="font-bold">Tài liệu đính kèm:</div>
                    {otherDetail?.attachments.length > 0 ? (
                      <div className="ml-1">
                        {otherDetail?.attachments.map(file => (
                          <FileItem
                            file={file}
                            key={file.file_id}
                            file_id={file.file_id}
                            file_name={file.file_name}
                            file_type={getExtensionFile(file.file_name)}
                          />
                        ))}
                      </div>
                    ) : (
                      <div className="ml-1 mt-1 mb-3 italic text-[12px]">
                        Không có tài liệu đính kèm.
                      </div>
                    )}
                  </div>
                </div>

                {/* Người theo dõi */}
                <div className="mb-3">
                  <div className="flex items-center">
                    <span className="font-bold">Người theo dõi:</span>
                    {otherDetail?.followers.length > 0 ? (
                      <div className="-mt-2">
                        {otherDetail?.followers.map((item, index) => (
                          <div
                            key={index}
                            className="border px-1 rounded-md text-blue-500 m-1">
                            {capitalizeFirstLetter(item.name_lowercase)}
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="ml-1 italic text-[12px]">
                        Không có người theo dõi.
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {otherCommentList?.length > 0 ? (
              <div className="m-4 border border-[#2c65ac] rounded-lg">
                <div
                  className="flex items-center bg-blue-600 px-4 py-2 rounded-t-lg"
                  style={{
                    background: theme.background.header,
                    color: theme.color.text1,
                  }}>
                  <div className="mr-2">Danh sách ý kiến</div>
                  <MoreHorizCircle onClick={handleClick} />
                  {menu}
                </div>
                <>
                  {commentProposalListDeleted?.length > 0 ? (
                    <div>
                      {openCmtDel ? (
                        <ListComment
                          loadingCmt={loadingCmt}
                          commentWorkList={commentProposalListDeleted}
                          setDeleteItem={setDeleteItem}
                        />
                      ) : (
                        ''
                      )}
                      <ListComment
                        loadingCmt={loadingCmt}
                        commentWorkList={commentProposalListNotDeleted}
                        setDeleteItem={setDeleteItem}
                      />
                    </div>
                  ) : (
                    <>
                      {commentProposalListNotDeleted?.length > 0 && (
                        <div>
                          {openCmtDel ? (
                            <ListComment
                              loadingCmt={loadingCmt}
                              commentWorkList={commentProposalListDeleted}
                              setDeleteItem={setDeleteItem}
                            />
                          ) : (
                            ''
                          )}
                          <ListComment
                            loadingCmt={loadingCmt}
                            commentWorkList={commentProposalListNotDeleted}
                            setDeleteItem={setDeleteItem}
                          />
                        </div>
                      )}
                    </>
                  )}
                </>
              </div>
            ) : null}
            <div className="m-4 border border-[#2c65ac] rounded-lg">
              <div
                className="bg-blue-600 px-4 py-2 rounded-t-lg flex items-center"
                style={{
                  background: theme.background.header,
                  color: theme.color.text1,
                }}>
                Chi tiết bảng lương từ file:
              </div>
              <>
                <h2
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    fontWeight: 600,
                    gap: '4px',
                  }}>
                  <FileItem
                    key={salaryInfo?.file_id}
                    file_id={salaryInfo?.file_id}
                    file_name={salaryInfo?.file_name}
                    file_type={utils.getExtensionFile(salaryInfo?.file_name)}
                    noPreview
                    noIcon
                  />
                </h2>
                <SalaryList
                  salaryData={salaryData}
                  isLoadingSalary={isLoadingSalary}
                  isShowSalaryInfo={isShowSalaryInfo}
                />
                {/* <div style={isShowSalaryInfo ? show : hide}>
                  <SalaryInfo />
                </div> */}
              </>
            </div>
          </div>
          <footer
            style={{
              position: 'fixed',
              bottom: 0,
              backgroundColor: 'white',
            }}
            className="flex items-center justify-between w-full py-4 rounded-t-[10px] shadow-[0px_0px_8px_rgba(0,0,0,0.25)]">
            <div className="flex justify-around w-full h-full">
              <div className="block text-center">
                <div
                  className="bg-[rgba(0,115,199,0.07)] inline-block text-blue-500 hover:bg-cyan-400 hover:text-white py-[8px] px-[8px] rounded-full text-sm font-medium"
                  onClick={() => setOpenCmtModal(true)}>
                  <AiOutlineComment style={{ width: '20px', height: '20px' }} />
                </div>
                <div style={{ fontSize: '10px' }}>Đăng ý kiến</div>
              </div>

              <div className="block text-center ">
                <div
                  onClick={() => {
                    setOpenEditProposal(true)
                    setCount(count + 1)
                    setIsModalOpen(true)
                  }}
                  className="hover:bg-cyan-400 inline-block
              bg-[rgba(0,115,199,0.07);] text-blue-500 hover:text-white py-[8px]
              text-center px-[8px] rounded-full text-sm font-medium">
                  <AiOutlineEdit style={{ width: '20px', height: '20px' }} />
                </div>
                <div style={{ fontSize: '11px' }}>Chỉnh sửa</div>
              </div>

              <div className="text-center ">
                <div
                  className="hover:bg-cyan-400 inline-block bg-[rgba(0,115,199,0.07)] text-red-500 hover:text-white  py-[8px] px-[8px] rounded-full text-sm font-medium"
                  onClick={() => showConfirmDeleteProposal()}>
                  <AiOutlineDelete style={{ width: '20px', height: '20px' }} />
                </div>
                <div style={{ fontSize: '10px' }}>Xóa</div>
              </div>
            </div>
          </footer>
          <SelectPeoplePopup
            onlyOneUser
            handleCancelSelectUser={handleSubmitSelectUser}
            handleSubmitSelectUser={handleSubmitSelectUser}
            isVisibleSelectPeoplePopup={isVisibleSelectUserPopup}
          />
          <SalaryComment
            open={openCmtModal}
            handleClose={() => {
              setOpenCmtModal(false)
            }}
            proposalCode={otherDetail.proposal_code}
            onCommentSuccess={onCommentSuccess}
          />
          {/* <AlertDialog
            open={deleteItem.open}
            handleClose={() => setDeleteItem({ open: false, comment_id: '' })}
            handleDelete={handleDeleteComment}
          />
          <ProposalActionConfirmModal
            isModalVisible={isConfirmModalVisible}
            handleCloseModal={handleCloseModal}
            confirmModalType={confirmModalType}
          />
          {openEditProposal && (
            <UpdateProposal
              count={count}
              setCount={setCount}
              open={openEditProposal}
              handleClose={() => {
                setOpenEditProposal(false)
              }}
              otherDetail={otherDetail}
              proposalTypeName={proposalTypeName}
              proposalType={otherDetail?.proposal_type}
            />
          )} */}
        </Fragment>
      )}
    </>
  )
}

export default memo(
  inject(
    'proposalStore',
    'selectPeopleStore',
    'proposalTypeStore',
    'authenticationStore',
    'proposalSalaryStore'
  )(observer(ProposalSalaryDetailPage))
)
